import InputText from "../../../../components/inputs/yup/materialui/inputText";
import { useForm } from "react-hook-form";
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { useEffect, useState } from "react";
import validaRut from "../../../../utils/validaRut";
import { companiaSeguro, companiaSeguroForm } from "../models/companiaSeguro";
import { useCompania } from "../hooks/useCompania";
import { useToast } from "../../../../hooks/useToast";
import InputRut from "../../../../components/inputs/yup/materialui/inputRut";
import { Dialog, DialogContent, DialogTitle, FormHelperText } from "@mui/material";
import Grid from '@mui/material/Grid2';
import MButton from "../../../../components/inputs/yup/materialui/mButton";
import { StatusCode } from "../../../../utils/enums";

interface IProps {
    show: boolean
    datosEditar: companiaSeguro | undefined
    onHide: () => void
    refresh: () => void
    setisloading: (loading: boolean) => void
    setrefresh: (value: boolean) => void
}

const ModalCompanias: React.FC<IProps> = ({ show, datosEditar, onHide, refresh, setisloading, setrefresh }) => {
    const { save } = useCompania();

    const validationSchema = yup.object().shape({
        id: yup.number().default(0),
        rut: yup.string().default('').nonNullable().test('valida-rut', 'RUT inválido', function (value) {
            return validaRut.rutFormat(value);
        }).required('Requerido'),
        nombre: yup.string().default('').nonNullable().required('Requerido').max(30, 'Máximo 30 caractéres'),
    })

    const {
        formState: { errors },
        handleSubmit,
        reset,
        setValue,
        control,
    } = useForm({ resolver: yupResolver(validationSchema) })

    const [isSubmitSuccessful, setIsSubmitSuccessful] = useState(false)
    const { addToast } = useToast();

    const onSubmit = (data: companiaSeguroForm) => saveCompania(data)

    useEffect(() => {
        reset()
    }, [isSubmitSuccessful])

    useEffect(() => {
        if (datosEditar && show) {
            setValue('id', datosEditar['id'])
            setValue('rut', datosEditar['rut'])
            setValue('nombre', datosEditar['nombre'])
        } else {
            reset()
        }
    }, [datosEditar, show])

    function customOnHide() {
        reset()
        onHide()
    }

    async function saveCompania(data: companiaSeguroForm) {
        setisloading(true)

        const response = await save(data, datosEditar)
        if (response.status === StatusCode.NoContent) {

            addToast({
                mostrar: true,
                titulo: 'Confirmación',
                tipo: 'Success',
                mensaje: 'La compañía de seguros se guardó con éxito.'
            });

            setrefresh(true)
            setIsSubmitSuccessful(true)
            refresh();
            onHide();
            reset();

        } else {

            addToast({
                mostrar: true,
                titulo: 'Error',
                tipo: 'Danger',
                mensaje: !datosEditar
                    ? 'No fue posible agregar la compañía de seguros. (Verifique que el rut no esté ya registrado)'
                    : 'No fue posible guardar la compañía de seguros. (Considere que el rut no puede ser modificado)',
            });
        }

        setisloading(false)
    }

    return (
        <Dialog
            open={show}
            onClose={customOnHide}
            maxWidth='lg'
        >
            <DialogTitle>
                {datosEditar ? 'Editar compañía seguros' : 'Nueva compañía seguros'}
            </DialogTitle>
            <DialogContent>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Grid container spacing={4}>
                        <Grid size={4}>
                            <InputRut
                                label="RUT"
                                name="rut"
                                control={control}
                                disabled={datosEditar != null} />
                            <FormHelperText error> {errors?.rut?.message} </FormHelperText>
                        </Grid>
                        <Grid size={8}>
                            <InputText
                                name="nombre"
                                control={control}
                                label="Nombre"
                            />
                            <FormHelperText error> {errors?.nombre?.message} </FormHelperText>
                        </Grid>
                    </Grid>
                </form>
                <Grid container spacing={1} marginTop={2} justifyContent={"flex-end"}>
                    <Grid>
                        <MButton variant="contained" onClick={handleSubmit(onSubmit)}>Guardar</MButton>
                    </Grid>
                    <Grid>
                        <MButton variant="contained" color="inherit" onClick={customOnHide}>Cancelar</MButton>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    )
}

export default ModalCompanias

